const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');
const ProgressList = () => import(/* webpackChunkName: "progress" */ '@/modules/progress/view/index.vue');
const ProgressEdit = () => import(/* webpackChunkName: "progress" */ '@/modules/progress/view/edit.vue');
const ProgressAddOrClone = () => import(/* webpackChunkName: "progress" */ '@/modules/progress/view/add.vue');
const ProgressLevelAdd = () => import(/* webpackChunkName: "progress" */ '@/modules/progress/level/view/add.vue');
const ProgressLevelEdit = () => import(/* webpackChunkName: "progress" */ '@/modules/progress/level/view/edit.vue');
const ProgressLevelList = () => import(/* webpackChunkName: "progress" */ '@/modules/progress/level/view/index.vue');
const ProgressLevelTranslate = () =>
    import(/* webpackChunkName: "progress" */ '@/modules/progress/level/view/translate.vue');
const ProgressPromotionItemList = () =>
    import(/* webpackChunkName: "progress" */ '@/modules/progress/promotion/view/index.vue');
const ProgressPromotionItemAdd = () =>
    import(/* webpackChunkName: "progress" */ '@/modules/progress/promotion/view/add.vue');
const ProgressPromotionItemClone = () =>
    import(/* webpackChunkName: "progress" */ '@/modules/progress/promotion/view/add.vue');
const ProgressPromotionItemDetail = () =>
    import(/* webpackChunkName: "progress" */ '@/modules/promotion/item/view/detail.vue');
const ProgressPromotionItemEdit = () =>
    import(/* webpackChunkName: "progress" */ '@/modules/promotion/item/view/edit.vue');
const ProgressPromotionItemTranslate = () =>
    import(/* webpackChunkName:"progress" */ '@/modules/promotion/item/view/translate.vue');

export const ROUTE_NAME_PROGRESS = {
    ITEM: {
        INDEX: 'ProgressList',
        ADD: 'ProgressAdd',
        CLONE: 'ProgressClone',
        EDIT: 'ProgressEdit'
    },
    LEVEL: {
        INDEX: 'ProgressLevelList',
        ADD: 'ProgressLevelAdd',
        EDIT: 'ProgressLevelEdit',
        TRANSLATE: 'ProgressLevelTranslate'
    },
    PROMOTION: {
        INDEX: 'ProgressPromotionItemList',
        ADD: 'ProgressPromotionItemAdd',
        EDIT: 'ProgressPromotionItemEdit',
        CLONE: 'ProgressPromotionItemClone',
        DETAIL: 'ProgressPromotionItemDetail',
        TRANSLATE: 'ProgressPromotionItemTranslate'
    }
};

export default [
    {
        path: '/app/:appId/progress',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'item',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROGRESS.ITEM.INDEX,
                        component: ProgressList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROGRESS.ITEM.ADD,
                        component: ProgressAddOrClone,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/clone',
                        name: ROUTE_NAME_PROGRESS.ITEM.CLONE,
                        component: ProgressAddOrClone,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_PROGRESS.ITEM.EDIT,
                        component: ProgressEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':progressId/',
                        component: EmptyRouterView,
                        meta: { requiresAuth: true },
                        children: [
                            {
                                path: 'level',
                                name: ROUTE_NAME_PROGRESS.LEVEL.INDEX,
                                component: ProgressLevelList,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'level/add',
                                name: ROUTE_NAME_PROGRESS.LEVEL.ADD,
                                component: ProgressLevelAdd,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'level/:level',
                                name: ROUTE_NAME_PROGRESS.LEVEL.EDIT,
                                component: ProgressLevelEdit,
                                meta: { requiresAuth: true }
                            },
                            {
                                path: 'level/:level/translate',
                                name: ROUTE_NAME_PROGRESS.LEVEL.TRANSLATE,
                                component: ProgressLevelTranslate,
                                meta: { requiresAuth: true }
                            }
                        ]
                    }
                ]
            },
            {
                path: 'promotion/item',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROGRESS.PROMOTION.INDEX,
                        component: ProgressPromotionItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROGRESS.PROMOTION.ADD,
                        component: ProgressPromotionItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_PROGRESS.PROMOTION.EDIT,
                        component: ProgressPromotionItemEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/clone',
                        name: ROUTE_NAME_PROGRESS.PROMOTION.CLONE,
                        component: ProgressPromotionItemClone,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROGRESS.PROMOTION.DETAIL,
                        component: ProgressPromotionItemDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_PROGRESS.PROMOTION.TRANSLATE,
                        component: ProgressPromotionItemTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
